import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

interface Response {
  upload_url?: string
  file_name?: string
  object_key?: string;
}

interface Payload {
  documentId: string;
  hashId?: string;
  name?: string;
  employeeId?: string;
}

const useCreateFileUploadUrlByLinkQuery = () => {
  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) => api.post<Response>(PATHS.CREATE_FILE_UPLOAD_URL_BY_LINK(payload?.documentId), {
      hash_id: payload?.hashId,
      name: payload?.name,
      employee_id: payload?.employeeId,
    })
  );

  return {
    createFileUploadUrlLink: mutateAsync,
    isLoading,
  };
};

export default useCreateFileUploadUrlByLinkQuery;
